<template>
  <div class="transfer-to-account">
    <WalletAccount :user-info="bankInfo" />

    <!-- 金额键盘和输入框 -->
    <FinancialNumberKeyboard
      v-model="money"
      :error.sync="moneyErrorMessage"
    />
    <div class="note-title">{{ $t('noteOptional') }}</div>

    <md-field>
      <md-input-item v-model="note" />
    </md-field>

    <div class="transfer-button">
      <md-button type="primary" @click="handleTransfer">
        {{ $t('transferTitle') }}
      </md-button>
    </div>
    <!-- 支付键盘 -->
    <PasswordPopup
      v-model="passwordVisiable"
      :code.sync="password"
      :error.sync="passwordError"
      @finished="confirmMethod"
    />
    <!-- 控制支付loading -->
    <PayLoading :is-show="showLoading" />
  </div>
</template>

<script>
import { Button, Toast, InputItem, Field } from 'mand-mobile'
import WalletAccount from '@/components/WalletAccount'
import FinancialNumberKeyboard from '@/components/FinancialNumberKeyboard'
import PasswordPopup from '@/components/PasswordPopup'
import PayLoading from '@/components/PayLoading'
import { transfer } from '@/api/transfer'
import { payeeUserInfo } from '@/api/common'
import {
  ERROR_REQ_CODE,
  TRADE_TITLE,
  TRANSACTION_STATUS
} from '@/constants'
import { limitAmount, tradeDetail, walletAll } from '@/api/withdraw'
import fenToYuan from '@/utils/fen-to-yuan'
import yuanToFen from '@/utils/yuan-to-fen'
import { formatAmount } from '@/utils/format-amount'
export default {
  name: 'TransferToAccount',
  components: {
    FinancialNumberKeyboard,
    WalletAccount,
    PasswordPopup,
    PayLoading,
    [Button.name]: Button,
    [InputItem.name]: InputItem,
    [Field.name]: Field
  },
  data () {
    return {
      bankInfo: {}, // 展示的信息
      moneyErrorMessage: '',
      note: '', // 备注
      money: '', // 输入金额
      passwordVisiable: false, // 控制密码键盘显示
      password: '', // 密码
      passwordError: '', // 密码错误信息
      limitAmount: '', // 转账限额
      allAmount: '', // 余额
      showLoading: false, // 弹框
      sendMoney: ''
    }
  },
  computed: {
    mobileNo () {
      return this.$route.query.payNumber
    }
  },

  created () {
    this.getPhoneOrPayInfo()
    this.getLimitAmount()
    this.getAllAmount()
  },
  destroyed () {
    this.clearInterval()
  },
  methods: {
    handleTransfer () {
      this.validateAmount()
        .then(() => { this.passwordVisiable = true })
        .catch((e) => {
          this.moneyErrorMessage = e.message
        })
    },
    validateAmount () {
      return new Promise((resolve, reject) => {
        const value = this.money
        if (this.limitAmount && value > this.limitAmount) {
          reject(new Error(`${this.$t('less_amount_message')}${formatAmount(this.limitAmount)}`))
        } else if (+value > this.allAmount) {
          reject(new Error(`${this.$t('less_amount_message')}${formatAmount(this.allAmount)}`))
        }

        resolve()
      })
    },
    // 根据手机号获取个人信息
    async getPhoneOrPayInfo () {
      this.bankInfo = await payeeUserInfo({ mobile: this.mobileNo })
    },
    // 转账限额
    async getLimitAmount () {
      const { limitAmount: amount } = await limitAmount({
        payProductCode: TRADE_TITLE.TransferToAccount
      })
      if (amount) this.limitAmount = fenToYuan(amount)
    },
    // 卡里余额
    async getAllAmount () {
      const data = await walletAll()
      this.allAmount = fenToYuan(data.balance)
    },
    async confirmMethod (password) {
      try {
        this.showLoading = true // 支付loading弹起
        this.passwordVisiable = false
        const {
          bankInfo: { userBankCardId },
          sendMoney,
          note
        } = this
        const { tradeNo } = await transfer({
          payeeMobile: this.mobileNo,
          password,
          amount: yuanToFen(sendMoney) || yuanToFen(this.money),
          userBankCardId,
          accountType: 0,
          note
        })
        this.tradeNo = tradeNo // 定时器中用到的参数
        this.createInterval()
      } catch (e) {
        this.showLoading = false
        this.passwordVisiable = false // 键盘隐藏
        if (e.code === ERROR_REQ_CODE.passError) {
          // 密码错误
          this.passwordVisiable = true // 键盘显示
          this.passwordError = e.message
        } else {
          e.code && Toast.failed(e.message, 4000, null, document.body, true)
        }
      }
    },
    async queryTradeDetail (tradeNo, countdown) {
      const { status } = await tradeDetail({ tradeNo }, (cancel) => {
        this.peddingCancel = cancel
      })
      // 交易订单状态 0:等待交易 1:银行受理中 2:银行处理中 3:交易成功 4:交易失败 5:超时交易关闭
      if (
        status === TRANSACTION_STATUS.pend ||
        status === TRANSACTION_STATUS.pending
      ) {
        // 银行受理中、银行处理中5S内继续请求
        this.peddingCancel = false
        if (countdown === 0) {
          // 5S内继续请求完后结果还是银行受理中或者银行处理中跳转到等待处理页面
          this.showLoading = false
          this.$router.replace({
            name: 'HaveNoStepsDetail',
            query: { tradeNo, path: 'TransferToAccount' }
          })
        }
      } else {
        // 清除定时器
        this.clearInterval()
        this.showLoading = false
        this.$router.replace({
          name: 'HaveNoStepsDetail',
          query: { tradeNo, path: 'TransferToAccount' }
        })
      }
    },
    clearInterval () {
      if (this.peddingCancel) {
        this.peddingCancel() // 终止请求
      }
      clearInterval(this.timer)
    },
    createInterval () {
      let countdown = 4
      const time = 1000
      this.timer = setInterval(() => {
        if (countdown <= 0) {
          this.showLoading = false
          this.clearInterval()
        } else if (!this.peddingCancel) {
          countdown--
          this.queryTradeDetail(this.tradeNo, countdown)
        }
      }, time)
    }
  }
}
</script>

<style lang="scss" scoped>
.transfer-to-account {
  height: 100%;
  padding: 0 40px;
}

.transfer-button {
  margin-top: 300px;
  padding-bottom: 50px;
}

.note-title {
  font-size: 24px;
  color: #333;
  font-weight: 400;
  line-height: 28px;
  margin-top: 102px;
}

.md-field {
  padding: 0;
}

::v-deep .md-field-item-content::before {
  z-index: 1;
}
</style>
